import template from './cameraSettingsModal.html';

/* @ngInject */
function CameraSettingsModalController(
  $q,
  $log,
  CameraService
) {
  const vm = this;

  const pendingSettingsPromises = new Map();

  vm.$onInit = init;
  vm.onLiveSettingsUpdate = onLiveSettingsUpdate;

  vm.loadingSpinners = false;


  function init() {
    _.forEach(vm.resolve, (val, key) => {
      vm[key] = val;
    });
    vm.camera = angular.copy(CameraService.getCamera(vm.panel.id, vm.cameraId));

    // Remove some leftover items from the copy.
    delete vm.camera.killVideo;
    delete vm.camera.playing;
    delete vm.camera.playerInterval;
    vm.camera.rotation = undefined;

    getRotation(vm.camera.id);

    getCameraResolutions(vm.camera.id);

    getLiveSettings(vm.camera.id);

    getEventSettings(vm.camera.id);

    getRecordingSettings(vm.camera.id);

    getDefaultAspectRatio(vm.camera.id);
  }

  function getRotation(id) {
    return CameraService.getRotation(id)
      .then(({ data }) => {
        vm.camera.rotation = data?.rotation;
      })
      .catch(logReject);
  }

  function getCameraResolutions(id) {
    return CameraService.getCameraResolutions(id)
      .then(({ data: resolutions }) => {
        vm.resolutions = resolutions;
      })
      .catch(logReject);
  }

  function getLiveSettings(id) {
    const type = 'live';
    const promise = CameraService.getLiveSettings(id)
      .then(({ data: settings }) => {
        vm.liveSettings = settings;
        stopLoadingSpinner();
      })
      .catch(logReject)
      .finally(() => settingsPromiseSettled(type));

    pendingSettingsPromises.set(type, promise);

    return promise;
  }

  function getEventSettings(id) {
    const type = 'event';
    const promise = CameraService.getEventSettings(id)
      .then(({ data: motion }) => {
        vm.eventSettings = motion;
        stopLoadingSpinner();
      })
      .catch(logReject)
      .finally(() => settingsPromiseSettled(type));

    pendingSettingsPromises.set(type, promise);

    return promise;
  }

  function getRecordingSettings(id) {
    const type = 'recording';
    const promise = CameraService.getRecordingSettings(id)
      .then(({ data: recording }) => {
        vm.recordingSettings = recording;
        stopLoadingSpinner();
      })
      .catch(logReject)
      .finally(() => settingsPromiseSettled(type));

    pendingSettingsPromises.set(type, promise);

    return promise;
  }

  function getDefaultAspectRatio(id) {
    return CameraService.getDefaultAspectRatio(id)
      .then(({ data: aspectRatio }) => {
        // TODO: figure out why sending just a string in dn-cameras is winding up here as { message: 'string' }
        vm.defaultAspectRatio = _.get(aspectRatio, 'message', aspectRatio);
      })
      .catch(_.noop);
  }

  function onLiveSettingsUpdate(liveSettings) {
    vm.liveSettings = liveSettings;
  }

  function logReject(err) {
    $log.error(err);
    return $q.reject();
  }

  function settingsPromiseSettled(type) {
    pendingSettingsPromises.delete(type);

    if (!pendingSettingsPromises.size) {
      stopLoadingSpinner();
    }
  }

  function stopLoadingSpinner() {
    if (!vm.loadingSpinners) {
      vm.loadingSpinners = true;
    }
  }
}

export default {
  name: 'cameraSettingsModal',
  template,
  controller: CameraSettingsModalController,
  controllerAs: 'CamSettingsModCtrl',
  bindings: {
    resolve: '<',
    dismiss: '&'
  }
};
